export default __webpack_public_path__ + "19730ff72b5c3e1ae323cd92afccb656.webp";